$(function() {
      if ($('body').hasClass('single-games') || $('body').hasClass('page-template-page-registration-form')) {
            if (!Cookie.get('hideAgePopup')) {
                  $('.overlay').addClass('overlay--visible');
                  $('.locationpopup').addClass('locationpopup--visible');
            }
      }

      $.ajax({
            type: 'GET',
            url: ajaxUrl,
            dataType: 'json',
            data: {
                  action: 'check_location',
            },
            success: function(data) {
                  var country = data.country.country.iso_code;
                  var cookie = Cookie.get('hideAgePopup');

                  if(!cookie){
                        if(country === 'GB'){
                              $('.overlay').addClass('overlay--visible');
                              $('.locationpopup').addClass('locationpopup--visible');
                              $('.js-hide-if-uk').remove();
                        }
                  } else {
                        if(country === 'GB') {
                              $('.js-hide-if-uk').remove();
                        }
                  }
            },
            error: function(xMLHttpRequest, errorThrown) {
                  console.log(errorThrown);
            }
      });

      function getAge(dateString) {
          var today = new Date();
          var birthDate = new Date(dateString);
          var age = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }

          return age;
      }

      $('.js-close-age-popup').on('click', function() {
            var bday = $('.js-birthday').val();
            var userAge = getAge(bday);

            if (userAge >= 18) {
                  Cookie.set('hideAgePopup', 'true');
                  $(this).parent().parent().removeClass('locationpopup--visible');
                  $('.overlay').removeClass('overlay--visible');
            } else {
                  $('.js-play-game').remove();
                  $('.locationpopup').html("<p>Sorry, since you're not over the age of 18 you can't view the content of this page. But you're welcome back when you've turned 18!</p>");
            }
      });
});
